import React, { useMemo } from "react";
import styled from "styled-components";
import useSettings from "../../../hooks/useSettings";

// system_configs.bookingRoomHolidays → [{ date, name }]. Accepts a JSON string
// too (older API builds return the raw column) and drops malformed entries.
const toHolidayList = (value) => {
  try {
    const list = typeof value === "string" ? JSON.parse(value) : value;
    return Array.isArray(list)
      ? list.filter((h) => h && typeof h.date === "string")
      : [];
  } catch (e) {
    return [];
  }
};

// Govt holidays from system config, as a { "YYYY-MM-DD": name } lookup.
export const useBookingHolidays = () => {
  const { setting } = useSettings();
  const value = setting?.bookingRoomHolidays;

  return useMemo(
    () =>
      toHolidayList(value).reduce(
        (acc, h) => ({ ...acc, [h.date]: h.name }),
        {},
      ),
    [value],
  );
};

// `renderDay` for @material-ui/pickers: highlights Govt holidays, with the
// holiday name as a hover tooltip.
export const renderHolidayDay =
  (holidays) => (day, selectedDate, dayInCurrentMonth, dayComponent) => {
    const name = dayInCurrentMonth && holidays[day.format("YYYY-MM-DD")];
    return name ? (
      <HolidayDay title={name}>{dayComponent}</HolidayDay>
    ) : (
      dayComponent
    );
  };

const HolidayDay = styled.div`
  & .MuiPickersDay-day:not(.MuiPickersDay-daySelected):not(.MuiPickersDay-dayDisabled) {
    color: #c2410c;
    font-weight: 700;
    background: rgba(246, 180, 54, 0.22);
  }
`;
